import Router from "./routes";
import { useEffect, useState } from "react";
import ThemeProvider from "./theme";
import ScrollToTop from "./components/scroll-to-top";
import { StyledChart } from "./components/chart";
import LoginPage from "./pages/LoginPage";
import { useSearchParams } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import { api } from "./api/api-client";
import { getStorageItem, StorageKeys } from "./lib/localStorage";

export default function App() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [showLogin, setShowLogin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = getStorageItem(StorageKeys.token);

    if (!token && !searchParams.has("token")) {
      setLoading(false);
      setShowLogin(true);
    } else if (!token && searchParams.has("token")) {
      api
        .post(`/admin/login-with-token`, {
          token: searchParams.get("token"),
        })
        .then(function (response) {
          localStorage.setItem(StorageKeys.token, response.data.token);
          localStorage.setItem("name", response.data.name);
          localStorage.setItem("role", response.data.role);
          setLoading(false);
          console.log(response.data);
        });
    } else {
      setLoading(false);
    }
  }, []);

  if (showLogin) {
    return (
      <ThemeProvider>
        <LoginPage />
      </ThemeProvider>
    );
  }
  return loading ? (
    <Box
      sx={{ display: "flex", justifyContent: "center" }}
      style={{ padding: 220 }}
    >
      <CircularProgress />
    </Box>
  ) : (
    <ThemeProvider>
      <ScrollToTop />
      <StyledChart />
      <Router />
    </ThemeProvider>
  );
}
